//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let operationData = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'comprehensiveData',
        component: _import('operationalData/comprehensiveData/index'),
        name: 'comprehensiveData',
        meta: {
          title: '综合运营数据',
          icon: 'widgets',
          keepAlive:false
        }
      }
    ]
  }
]
export default operationData;